// extracted by mini-css-extract-plugin
export default {"sortButton":"sort-column-button-module__sortButton--H2m0v"};